import { jsx as i } from "react/jsx-runtime";
import { aC as f, b2 as _, b3 as m, d as b } from "../../vendor-Dd6qj6gJ.js";
import { useRef as l } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { useAutoResize as x, supportsFieldSizing as d } from "./useAutoResize.js";
import '../../assets/index58.css';const u = "_textArea_1wr9r_1", $ = "_autoResize_1wr9r_44", A = "_both_1wr9r_48", R = "_vertical_1wr9r_52", w = "_none_1wr9r_56", t = {
  textArea: u,
  autoResize: $,
  both: A,
  vertical: R,
  none: w
};
function j({
  className: s,
  resize: c = "both",
  autoResize: o = !1,
  maxRows: a,
  ...r
}) {
  const e = l(null), [{ value: n }] = f(r, e, _);
  return x(e, { isEnabled: o, value: n, maxRows: a }), /* @__PURE__ */ i(
    m,
    {
      ...p(r),
      ref: e,
      className: b(t.textArea, t[c], s, {
        [t.autoResize]: o && d
      }),
      "data-component": "TextArea"
    }
  );
}
export {
  j as TextArea
};
